import { render, staticRenderFns } from "./Tip3.vue?vue&type=template&id=a2a9e920&scoped=true&lang=pug"
import script from "./Tip3.vue?vue&type=script&lang=ts"
export * from "./Tip3.vue?vue&type=script&lang=ts"
import style0 from "./Tip3.vue?vue&type=style&index=0&id=a2a9e920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a9e920",
  null
  
)

export default component.exports